import { Pipe, PipeTransform } from '@angular/core';
import { AbstractControl, Validators } from '@angular/forms';

@Pipe({ name: 'isControlRequired' })
export class IsControlRequiredPipe implements PipeTransform {
  transform(formControl?: AbstractControl): boolean {
    if (formControl) {
      return formControl.hasValidator(Validators.required)
        || formControl.hasValidator(Validators.requiredTrue);
    }
    return false;
  }
}
